"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileService = void 0;
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var ProfileService = /** @class */ (function () {
    function ProfileService() {
    }
    ProfileService.prototype.setCurrentProfileVersionId = function (profileId) {
        this.currentProfileVersionId = profileId;
    };
    ProfileService.prototype.initProfileList = function (profileList) {
        if (this.profileList) {
            console.warn('You should only init this.profileList for once\n', "this.profileList === profileList = " + (this.profileList === profileList), this.profileList, profileList);
        }
        this.profileList = profileList;
    };
    ProfileService.prototype.getCurrentProfileVersionId = function () {
        return this.currentProfileVersionId;
    };
    ProfileService.prototype.getAllProfileList = function () {
        return this.profileList;
    };
    ProfileService.prototype.getCurrentProfile = function () {
        var _this = this;
        var _a, _b, _c;
        return (((_a = this.profileList) === null || _a === void 0 ? void 0 : _a.find(function (p) { return p.ProfileVersionId === _this.currentProfileVersionId; })) ||
            ((_b = this.profileList) === null || _b === void 0 ? void 0 : _b.find(function (p) { return p.IsDefault; })) ||
            ((_c = this.profileList) === null || _c === void 0 ? void 0 : _c[0]));
    };
    ProfileService = __decorate([
        CommonService_decorator_1.CommonService('ProfileService')
    ], ProfileService);
    return ProfileService;
}());
exports.ProfileService = ProfileService;
//# sourceMappingURL=Profile.service.js.map